<app-cardholder-details
  *ngIf="cardholder"
  [cardholder]="cardholder"
  (newCardholderSelected)="showNewCardholder($event)">
</app-cardholder-details>
<p>
  cardholder-profiles works!
</p>
